function _createForOfIteratorHelper(o) { if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) { var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var it, normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * Capitan anchor-nav v1.0.0
 *
 * Copyright brandung GmbH & Co.KG
 * http://www.Capitan.de/
 *
 * Date: 2019-10-28
 * MIT License (MIT)
 */
import Capitan from '../../code/js/Capitan/Capitan';
import CapBodyScroll from '../../code/js/Capitan/es6/CapBodyScroll';
import CapSmartResize from '../../code/js/Capitan/es6/CapSmartResize';
var _ = {
  defaults: {
    componentSelector: '.anchor-nav',
    selectors: {
      navContainer: '',
      mobileNav: '.header',
      desktopNavAnchor: '.anchor-nav',
      mobileNavAnchor: '.anchor-nav',
      anchorNav: '.anchor-nav',
      mainNavTarget: '.nav-desktop',
      mainNavFlyout: '.nav-desktop__flyout',
      heroSlider: '.stage-hero-slider--top'
    },
    classes: {
      stickyClass: 'has-anchor',
      activeClass: 'anchor__link--active',
      offCanvas: 'off-canvas',
      stickyAnchorNav: 'is-anchor-nav-sticky'
    },
    accesors: {
      anchorOffset: 0,
      scrollPos: 0,

      get getAnchorOffset() {
        return this.anchorOffset;
      },

      set setAnchorOffset(newOffset) {
        this.anchorOffset = newOffset;
      },

      get getScrollPos() {
        return this.scrollPos;
      },

      set setScrollPos(newScrollPos) {
        this.scrollPos = newScrollPos;
      }

    },
    scrollParameters: {
      triggerDelay: 400,
      timeout: null
    },
    isScrolling: false
  }
};
var o = _.defaults;

var anchorLinkListener = function anchorLinkListener() {
  document.querySelectorAll('.anchor__link').forEach(function (link) {
    link.addEventListener('click', clickAnchorLink);
  });
};

var scrollTo = function scrollTo(scrollToElement) {
  console.log(scrollToElement);
  var paddingCheck = scrollToElement.classList.contains('u-reset-padding-top') || scrollToElement.classList.contains('text-teaser');

  if (!paddingCheck) {
    var headerOffset = 0;
    o.isScrolling = true;
    CapBodyScroll(scrollToElement, headerOffset);
  } else {
    var _headerOffset = 100;
    o.isScrolling = true;
    CapBodyScroll(scrollToElement, _headerOffset);
  }
};

var bindEvents = function bindEvents(swiper) {
  anchorLinkListener();
  window.addEventListener('scroll', function (e) {
    e.stopPropagation();
    scrollHandler(e, swiper);
  });
  window.addEventListener('load', function (e) {
    if (window.location.hash !== '') {
      var urlHash = window.location.hash;
      var id = removePotentialHash(urlHash);
      var linkElement = document.getElementById(id);
      scrollTo(linkElement);
    } else {
      // call scrollhandler after initial page load for users who refresh at the middle of the page
      scrollHandler(e, swiper);
    }
  }, true);
};

var clickAnchorLink = function clickAnchorLink(e) {
  console.log(e);
  e.preventDefault();
  e.target.classList.add(o.classes.activeClass);
  var id = removePotentialHash(e.target.dataset.target);
  var goToElement = document.getElementById(id);
  scrollTo(goToElement);
};

document.addEventListener('scrollStop', function () {
  o.isScrolling = false;
}, false);

var isInViewport = function isInViewport(element) {
  var _element$getBoundingC = element.getBoundingClientRect(),
      top = _element$getBoundingC.top,
      bottom = _element$getBoundingC.bottom;

  var viewHeight = window.innerHeight || document.documentElement.clientHeight;
  var vHeight = viewHeight - viewHeight / 2;
  return (top > 0 || bottom > 0) && top < vHeight;
};

var scrollHandler = function scrollHandler(e, swiper) {
  var scrollPos = window.pageYOffset;
  o.accesors.setScrollPos = scrollPos;

  if (isInViewport(swiper.$el[0])) {
    setCurrentAnchor(swiper);
  }
};

var setCurrentAnchor = function setCurrentAnchor(swiper) {
  // Changes active item
  var anchors = document.querySelectorAll('.anchor-nav .anchor__link');
  var currentAnchor;

  var _iterator = _createForOfIteratorHelper(anchors),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var anchor = _step.value;
      var currentId = removePotentialHash(anchor.dataset.target);
      var currentSection = document.getElementById(currentId);
      anchor.classList.remove(o.classes.activeClass);

      if (currentSection && isInViewport(currentSection)) {
        currentAnchor = anchor;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  if (currentAnchor && !o.isScrolling) {
    currentAnchor.classList.add(o.classes.activeClass);
    var slide = currentAnchor.closest('.swiper-slide');
    var slideParent = slide.parentNode;
    swiper.slideTo(Array.prototype.indexOf.call(slideParent.children, slide));
  }
};

var onResize = function onResize(currentDomElement) {
  if (currentDomElement) {
    var scrollTop = window.pageYOffset;
    o.accesors.setAnchorOffset = currentDomElement.getBoundingClientRect().top - 40 + scrollTop;
    var swiper = currentDomElement.querySelector('.swiper');

    if (swiper.offsetWidth < swiper.scrollWidth) {
      swiper.classList.add('anchor-nav--swipeable');
    } else {
      swiper.classList.remove('anchor-nav--swipeable');
    }
  }
};

var removePotentialHash = function removePotentialHash(string) {
  if (string.charAt(0) === '#') {
    return string.substr(1);
  }

  return string;
};
/**
 * Init component
 */


export function init(currentDomElement, swiper) {
  bindEvents(swiper);
  CapSmartResize(function () {
    onResize(currentDomElement);
  });
  onResize(currentDomElement);
}